export default __webpack_public_path__ + "static/media/board-bg.4984ae5e.jpg";